// Обновление чатов после изменения доступа текущего сотрудника к сущности.
// Прикрепление/открепление себя в блоке Сотрудники меняет набор доступных чатов,
// а SignalR-события на это не приходят — обновляем оба стора вручную.
import { chatsStore } from "@/store/chats"
import { headerStore } from "@/store/header"
import { workerStore } from "@/store/worker"

/** Текущий авторизованный сотрудник. */
export function isCurrentWorker(workerId: number): boolean {
    const profileId = workerStore().workerProfile?.Id
    return !!profileId && profileId === workerId
}

/**
 * Перечитывает список диалогов на Главной и в шапке (бейдж непрочитанных
 * считается из этого же списка), обновляет уведомления и закрывает открытый
 * чат, если доступ к нему пропал.
 */
export async function refreshDialogsAfterAccessChange(): Promise<void> {
    const chat = chatsStore()
    const header = headerStore()

    await Promise.all([
        chat.fetchDialogs(),
        header.fetchDialogs(),
        header.refreshAfterSocket(),
    ])

    for (const store of [chat, header]) {
        const openedChatId = store.openedChat
        if (openedChatId === null) {
            continue
        }
        if (store.dialogs.some(dialog => dialog.Id === openedChatId)) {
            continue
        }
        store.deleteOpenedChatsHistory(openedChatId)

        if (store.openedChat === openedChatId) {
            await store.setOpenedChat(null)
            store.releaseChatData(openedChatId)
        }
    }
}
